import { useParams } from 'react-router-dom';
import ISolvedLandingPage from './ISolvedLandingPage';

export const ISolvedAASLandingPage = () => {
  const { companyId, caseId } = useParams();

  if (!companyId || !caseId) {
    return null;
  }

  return <ISolvedLandingPage
    companyId={companyId}
    caseId={caseId} />;
}; 